import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '~/player/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('~/player/pages/LoginPage.vue'),
    meta: { guest: true }
  },
  {
    path: '/',
    name: 'providers',
    component: () => import('~/player/pages/ProvidersPage.vue')
  },
  {
    path: '/providers/:id',
    name: 'categories',
    component: () => import('~/player/pages/CategoriesPage.vue')
  },
  {
    path: '/providers/:id/categories/:categoryId',
    name: 'games',
    component: () => import('~/player/pages/GamesPage.vue')
  },
  {
    path: '/play/lobby/:providerId',
    name: 'play-lobby',
    component: () => import('~/player/pages/PlayPage.vue'),
    meta: { hideNav: true }
  },
  {
    path: '/play/:gameId',
    name: 'play',
    component: () => import('~/player/pages/PlayPage.vue'),
    meta: { hideNav: true }
  },
  {
    path: '/wallets',
    name: 'wallets',
    component: () => import('~/player/pages/WalletsPage.vue'),
    meta: { transferOnly: true }
  },
  {
    path: '/bet-logs',
    name: 'bet-logs',
    component: () => import('~/player/pages/BetLogsPage.vue')
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: () => import('~/player/pages/TransactionsPage.vue')
  },
  // 舊路徑 /records 重導到投注紀錄，避免外部書籤失效
  {
    path: '/records',
    redirect: '/bet-logs'
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('~/player/pages/ProfilePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const token = localStorage.getItem('player_token')
  if (!to.meta.guest && !token) {
    return '/login'
  }
  if (to.meta.guest && token) {
    return '/'
  }

  // 單錢包（seamless）玩家不需要 /wallets 頁
  if (to.meta.transferOnly && token) {
    const auth = useAuthStore()
    await auth.ensureProfile()
    if (auth.isSeamless) return '/'
  }
})

export default router
